import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ProposalTypeOfVisit, ProposalReduxState as StateType } from "./types";

import InfoReducers from "./reducers/infoReducer";
import ProductReducers from "./reducers/productsReducer";
import MaterialReducers from "./reducers/materialsReducer";
import LoadingReducers from "./reducers/loadingReducer";
import ResumenFieldsReducer from "./reducers/resumenFields";
import SlidesReducers from "./reducers/slidesReducer";

import { defaultResumenFields } from "./constants";

export const initialState: StateType = {
  currentStep: 0,
  maxStep: 0,

  proposalId: undefined,
  proposalInformation: {
    typeOfVisit: ProposalTypeOfVisit.Default,
  },

  products: [],
  materials: [],

  ads: undefined,
  guarantees: undefined,
  resumeFields: defaultResumenFields,

  isDirectBilling: false,
  isTankBilling: false,

  isUpdated: true,
  isLoading: false,

  priceNetById: {},

  // Slides
  slides: [],
  slidesGeneration: {
    progress: 0,
    isError: false,
  },

  // For Sherpa New Products
  newProducts: [],
};

const slice = createSlice({
  name: "proposal",
  initialState,
  reducers: {
    SetCurrentStep(
      state: StateType,
      { payload: newStep }: PayloadAction<number>,
    ) {
      state.currentStep = newStep;
      if (state.maxStep < newStep) {
        state.maxStep = newStep;
      }
    },

    ...InfoReducers,
    ...ProductReducers,
    ...MaterialReducers,
    ...LoadingReducers,
    ...ResumenFieldsReducer,
    ...SlidesReducers,

    // Reset Proposal State
    ResetProposalState() {
      return initialState;
    },
  },
});

export const {
  SetCurrentStep,

  // Proposal Info
  SetProposalInfo,
  UpdateProposalInfo,
  UpdateProposalInfoField,
  UpdateProductPriceNet,

  // Products
  AddProductsToProposal,
  UpdateProposalProduct,
  UpdateProposalProductOrder,
  RemoveProductsFromProposal,
  UpdateProposalProducts,
  RemoveProductsFromProposalByProduct,

  // Materials
  AddMaterialToProposal,
  AddMaterialsToProposal,
  UpdateProposalMaterial,
  RemoveMaterialsFromProposal,
  UpdateProposalMaterials,
  RemoveMaterialsFromProposalByProductId,

  // Resumen
  UpdateResumenFields,
  UpdateMultiResumenFields,
  UpdateGuaranteesFields,

  // Slides
  SetProposalSlides,
  UpdateProposalSlide,
  SetProposalError,
  SetProposalProgression,

  // Loadings
  SetProposalLoading,

  // Reset
  ResetProposalState,
} = slice.actions;

export default slice.reducer;
